import {
  LIST_ALERT_TYPES_REQUEST,
  LIST_ALERT_TYPES_RESPONSE,
  LOGOUT_RESPONSE,
} from '../constants'

// [alert_type]
const initialState = []

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_ALERT_TYPES_REQUEST: {
      const s = [...state]
      s.isLoading = true
      return s
    }
    case LIST_ALERT_TYPES_RESPONSE: {
      return action.alertTypes
    }
    case LOGOUT_RESPONSE:
      return initialState
    default:
      return state
  }
}
